import React, { useCallback } from "react";
import { FunctionComponent } from "react";

interface IProps {
	children: React.ReactElement;
	groupName: string;
	first?: boolean;
}

const ArrowTabItem: FunctionComponent<IProps> = (props) => {
	const { first, groupName, children } = props;
	const inputReactObject = React.Children.only(children);

	const arrowTab = useCallback((event: KeyboardEvent) => {
		switch (event.key) {
			case "ArrowLeft":
				Prev(event.target as HTMLElement, groupName)?.focus();
				event.stopPropagation();
				event.preventDefault();
				return;
			case "ArrowRight":
				Next(event.target as HTMLElement, groupName)?.focus();
				event.stopPropagation();
				event.preventDefault();
				return;
		}
	}, [groupName]);

	const clonnedChild = React.cloneElement(inputReactObject, {
		className: inputReactObject.props.className ? `${inputReactObject.props.className} arrowTabElement ${groupName}` :"arrowTabElement " + groupName,
		tabIndex: first ? 0 : -1,
		onKeyDown: arrowTab,
	});

	return clonnedChild;
}

const Next = (element: HTMLElement | null, selector?: string): HTMLElement | null => {
	if (!element) { return null; }
	const nextElement = element.nextElementSibling;

	if (!selector) { return nextElement as HTMLElement; }

	if (nextElement && nextElement.matches(`.${selector}`)) { return nextElement as HTMLElement; }

	const elements = document.getElementsByClassName(selector);
	let found = false;
	for (const e of Array.from(elements)) {
		if (e === element) { found = true; continue; }
		if (found) {
			return e as HTMLElement;
		}
	}

	return null;
}

const Prev = (element: HTMLElement | null, selector?: string): HTMLElement | null => {
	if (!element) { return null; }
	const prevElement = element.previousElementSibling;

	if (!selector) { return prevElement as HTMLElement; }

	if (prevElement && prevElement.matches(`.${selector}`)) { return prevElement as HTMLElement; }

	const elements = document.getElementsByClassName(selector);
	let prev: Element | false = false;
	for (const e of Array.from(elements)) {
		if (e === element) { 
			if (!prev) { return null; }
			return prev as HTMLElement; 
		}
		prev = e;
	}

	return null;
}

export default ArrowTabItem;